const React = require('react');
const formatNum = require('../../../../utils/formatNum');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonA = require('../../../dumb/Button/A');
const ButtonUp = require('../../../dumb/Button/Up');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');

const {
  DisplayDataAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/orderedTerminals')
      .apiAdminOrderedTerminalsList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const count = data.count || 0;
      const time = data.time || '';
      return (
        <RowA>
          <ColA className="wmin115">
            <DisplayDateTimeAdmin date={time} />
          </ColA>
          <ColA className="wmin120 fx1">
            <DisplayDataAdmin>{data.company_name}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin180 fx1">
            <DisplayDataAdmin>{data.username}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin120 fx1">
            <DisplayDataAdmin>{data.status}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin120">
            <DisplayDataAdmin>{data.color}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin80">
            <DisplayDataAdmin
              title={count}
            >{formatNum(count)}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin110">
            <ButtonA
              disabled
              className="rt"
            >Button</ButtonA>
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Ordered terminals</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin800 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin115">Date & Time</ColB>
                    <ColB className="wmin120 fx1">Company</ColB>
                    <ColB className="wmin180 fx1">User</ColB>
                    <ColB className="wmin120 fx1">Status</ColB>
                    <ColB className="wmin120">Color</ColB>
                    <ColB className="wmin80">Count</ColB>
                    <ColB className="wmin110"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
